import { WindowLocation } from "@reach/router";
import { graphql } from "gatsby";
import React from "react";
import LandingPageContent from "../components/LandingPageContent/LandingPageContent";
import PageLayout from "../layouts/PageLayout/PageLayout";
import { CommonContext } from "../model/common";
import { SanityLandingPage } from "../model/landing-page";
import { GlobalMenus } from "../model/menu";
import { SiteArea } from "../utils/analytics";

export const pageQuery = graphql`
  query AboutLandingPage($_id: String!, $navLanguage: String) {
    menus: sanityGlobalConfig(language: { eq: $navLanguage }) {
      ...MenuData
    }
    page: sanityAboutLandingPage(_id: { eq: $_id }) {
      _id
      _type
      language
      title
      metaDescription
      socialTitle
      socialDescription
      socialImage {
        ...SanityImage
      }
      _rawContent(resolveReferences: { maxDepth: 11 })
    }
  }
`;

const AboutLandingPage = ({
  pageContext,
  data: { menus, page },
  location
}: AboutLandingPageProps) => {
  const { title } = page;
  return (
    <PageLayout
      siteArea={SiteArea.ABOUT}
      metadata={{
        title,
        page,
        alternates: pageContext.alternates
      }}
      menus={menus}
      messages={pageContext.messages}
      location={location}
    >
      <LandingPageContent content={page._rawContent} title={page.title} />
    </PageLayout>
  );
};

interface AboutLandingPageProps {
  data: {
    menus: GlobalMenus;
    page: SanityLandingPage;
  };
  location: WindowLocation;
  pageContext: CommonContext;
}

export default AboutLandingPage;
